import { RegisterUserRequest } from './../../models/account/registerUserRequest';
import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { validateEmailResponse } from '../../models/account/validateEmailResponse';
import { Observable } from 'rxjs';
import { loginRequest } from '../../models/account/loginRequest';
import { loginResponse } from '../../models/account/loginResponse';
import { VerifyOTPResponse } from '../../models/account/verifyOTPResponse';
import { verifyOTPRequest } from '../../models/account/verifyOTPRequest';
import { UserStateModel } from '../../states/user/user-state-model';
import { JWTTokenRequest } from '../../models/account/jwtTokenRequest';
import { UserResponse } from '../../models/account/userResponse';
import { UpdatePasswordRequest } from '../../models/account/updatePasswordRequest';
import { ForgotPasswordRequest } from '../../models/account/forgotPasswordRequest';
import { UserState } from '../../states/user/user-state';
import { ValidatePhoneRequest } from '../../models/account/validatePhoneRequest';
import { ValidatePhoneResponse } from '../../models/account/validatePhoneResponse';
import { VerifyPhoneOTPRequest } from '../../models/account/verifyPhoneOTPRequest';
import { VerifyPhoneOTPResponse } from '../../models/account/verifyPhoneOTPResponse';
import { CreateAccountRequest } from '../../models/account/createAccountRequest';
import { GoogleLoginRequest } from '../../models/account/googleLoginRequest';
import { LinkedInLoginRequest } from '../../models/account/linkedinLoginRequest';
import { HttpResponse } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private genericService: GenericService) { }

  validateEmail(email: string): Observable<validateEmailResponse>
  {
    return this.genericService.get(`user/${email}/validate`);
  }

  validateForgetPasswordEmail(email: string): Observable<validateEmailResponse>
  {
    return this.genericService.get(`user/forgetpassword/${email}/validate`);
  }

  forgotPassword(req: ForgotPasswordRequest): Observable<loginResponse>
  {
    return this.genericService.patch(`user/forgetpassword`, req);
  }

  login(loginRequest:loginRequest):Observable<loginResponse>{
    return this.genericService.post(`user/login`,loginRequest);
  }

  verifyOTP(verifyOTPRequest: verifyOTPRequest):Observable<VerifyOTPResponse>{
    return this.genericService.post(`user/verify`,verifyOTPRequest)
  }

  registerUser(RegisterUserRequest: RegisterUserRequest):Observable<loginResponse>
  {
    return this.genericService.post(`user/register`,RegisterUserRequest);
  }

  getUser():Observable<UserStateModel>
  {
    return this.genericService.get(`user`);
  };

  getUserByid(id:string):Observable<UserResponse>
  {
    return this.genericService.get(`user/${id}`);
  };

  getJWTbyRefreshToken(jWTTokenRequest:JWTTokenRequest):Observable<loginResponse>
  {
    return this.genericService.post(`user/jwttoken`,jWTTokenRequest);
  };

  updatePassword(updatePasswordRequest: UpdatePasswordRequest):Observable<string>
  {
    return this.genericService.patch(`user/updatepassword`, updatePasswordRequest);
  }

  validatePhone(validatePhoneRequest: ValidatePhoneRequest): Observable<ValidatePhoneResponse>
  {
    return this.genericService.post(`user/phone/validate`, validatePhoneRequest);
  }

  verifyPhoneOTP(verifyPhoneOTPRequest: VerifyPhoneOTPRequest): Observable<VerifyPhoneOTPResponse>
  {
    return this.genericService.post(`user/phone/verify`, verifyPhoneOTPRequest);
  }

  createAccount(createAccountRequest: CreateAccountRequest): Observable<loginResponse>
  {
    return this.genericService.post(`user/create-account`, createAccountRequest);
  }
  updateAccount(userId: string, createAccountRequest: CreateAccountRequest): Observable<loginResponse>
  {
    return this.genericService.post(`user/update-account/${userId}`, createAccountRequest);
  }

  googleLogin(googleLoginRequest: GoogleLoginRequest): Observable<loginResponse>
  {
    return this.genericService.post(`user/google-login`, googleLoginRequest);
  }

    linkedinLogin(linkedinLoginRequest: LinkedInLoginRequest): Observable<loginResponse> {
    return this.genericService.post(`user/linkedin-login`, linkedinLoginRequest);
  }
}
